export default {
  heading: 'text-md! text-[black]',
  labelClass: 'font-bold! text-black!',
};
